import TYPES from '@/modules/shared/types';

// Domain
import {
  FinalInvestmentDateCalculatorRepository,
} from '../../domain/repositories/final-investment-date-calculator-repository';
import { FinalInvestmentDateCalculatorDto }
  from '../../domain/dtos/final-investment-date-calculator-dto';
import { FinalInvestmentDateCalculatorEntity }
  from '../../domain/entities/final-investment-date-calculator-entity';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class FinalInvestmentDateCalculatorHttpRepository implements
  FinalInvestmentDateCalculatorRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/flagship/investor-goal/final-investment-date-calculator/`;

  get_final_investment_date(final_investment_date_dto: FinalInvestmentDateCalculatorDto):
    Promise<FinalInvestmentDateCalculatorEntity> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint, 'POST', final_investment_date_dto)
        .then((response) => {
          response.json()
            .then(({ success, data, message }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(message));
              }
            });
        })
        .catch(reject);
    });
  }
}
